/* v8.6: single source of truth for the app version. Used by serializeDB's data-file
   header and the PORTFOLIO meta.
   ⚠ v12.3 retired the static header stamp, so a version bump touches THREE spots, all
   greppable and none of them markup: this const · the live data file's first line ·
   qa/qa_fixture_data.js's first line (forgetting the fixture fails roundtrip_byte_exact
   on the very next harness run, because serializeDB emits APP_VERSION into the header). */
const APP_VERSION = 'v18.0';
/* v10.3 (W2): single source of truth for the data-file schema. The number used to be
   hardcoded at every gate (the boot block, the programme module-load pass) — and v10.3
   added a third gate inside _adoptDB, so a literal would have been a fourth copy to keep
   in sync. Bumping this const is now the ONLY place the expected schema is stated.
   ⚠ Since v10.2 the data file holds real user data: raising this number REQUIRES a real
   migration path first (the back-compat window is closed — see HANDOVER §0). */
const SCHEMA_VERSION = 10;
